const SelectMode = ({
  label,
  name,
  options = [
    { value: "air", label: "Air Mode" },
    { value: "surface", label: "Surface Mode" },
  ],
  selectedValue, // No default value; it should come from the parent
  onChange,
  className = "",
  labelClassName = "",
  optionClassName = "",
  radioClassName = "",
  disabled = false,
}) => {
  return (
    <div className={`w-full flex flex-col gap-2 ${className}`}>
      {label && (
        <label
          className={`text-body1 font-ptsans text-secondary/90 font-medium pl-2 block ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <div className="flex gap-3 pl-2 ">
        {options.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <label
              key={option.value}
              className={`flex items-center w-fit px-2 ${option.subOption? "py-2 pr-3":"py-4"} rounded-xl text-secondary/80 text-body1 font-ptsans border cursor-pointer transition-all ease-in-out duration-200
                ${
                  isSelected
                    ? "bg-primary/20 border-primary text-secondary font-semibold"
                    : disabled
                    ? "cursor-not-allowed bg-secondary/35 border-secondary/20"
                    : "bg-secondary/5 border-secondary/30 "
                } ${optionClassName}`}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isSelected}
                onChange={(e) => {
                  if (!disabled) {
                    onChange(option.value);
                  }
                }}
                disabled={disabled}
                className={`mr-2 appearance-none w-3 h-3 subtitle2 border rounded-full checked:bg-primary 
                  ${
                    isSelected
                      ? "border-primary bg-primary"
                      : disabled
                      ? "cursor-not-allowed bg-secondary/35 border-secondary/20"
                      : "border-secondary/20 bg-transparent "
                  } ${radioClassName}`}
              />
               <div className="flex flex-col">
                {option.subOption?.label && (
                  <span className="text-caption text-secondary/60">{option.subOption.label}</span>
                )}
                <span>{option.label}</span>
              </div>
              {/* <span>{option.label}</span> */}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default SelectMode;
